var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlantao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0899ba;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.07,9.414a2.934,2.934,0,0,0-2.87,2.344h-.723a2.933,2.933,0,0,0-2.93,2.93V17.07a1.758,1.758,0,0,1-3.516,0v-1.9A1.755,1.755,0,0,0,8.2,13.516V12.48c2.79-1.4,4.687-5.869,4.687-8.379,0-1.4-.128-2.089-1.212-2.71a1.769,1.769,0,1,0-.214,1.263c.219.236.254.585.254,1.448,0,2.865-2.554,7.656-5.273,7.656S1.172,6.967,1.172,4.1c0-.863.035-1.212.254-1.448a1.75,1.75,0,1,0-.214-1.263C.128,2.012,0,2.7,0,4.1c0,2.51,1.9,6.976,4.688,8.379v1.035a1.755,1.755,0,0,0,1.172,1.65v1.9a2.93,2.93,0,1,0,5.859,0V14.688a1.76,1.76,0,0,1,1.758-1.758H14.2a2.93,2.93,0,1,0,2.87-3.516Zm.586,3.516H16.484V11.758h1.172Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlantao);
export default __webpack_public_path__ + "static/media/icon-plantao.609ffa1b4a604d9109cf59e1b400570c.svg";
export { ForwardRef as ReactComponent };